import { render, staticRenderFns } from "./FirmFilesTable.vue?vue&type=template&id=e6dd840a&scoped=true"
import script from "./FirmFilesTable.vue?vue&type=script&lang=js"
export * from "./FirmFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6dd840a",
  null
  
)

export default component.exports